// extracted by mini-css-extract-plugin
module.exports = {"VideoControls":"VideoControls_VideoControls__rUv5G","button":"VideoControls_button__Kwjk1","captions":"VideoControls_captions__3sS7C"};